// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"af8afda3","379":"149dd682","404":"5d4f5485"}[chunkId] + ".chunk.js";
};